import { useContext } from "react";
import { Container, Grid, Box, Typography } from "@mui/material";
import { SupportAgent, Email } from "@mui/icons-material";
import styles from "./Styles.module.css";
import RedesDiv from "./Columns/RedesDiv";
import ContactFlotanteDiv from "./Columns/ContactFlotanteDiv";
import logo from "../images/logoFooterEmpresa.png";
import { AuthContext } from "../../context/authContext";
const appUrl = process.env.REACT_APP_URL_BACKEND;

const ContactCard = ({ title, subtitle, detail, icon }) => (
  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, p: 2.5, borderRadius: "var(--radius-lg)", border: "1px solid var(--border)", backgroundColor: "var(--bg-card)", width: "100%", transition: "all 0.2s ease", "&:hover": { borderColor: "var(--border-hover)", boxShadow: "var(--shadow-sm)" } }}>
    <Box sx={{ width: 44, height: 44, borderRadius: "var(--radius-md)", backgroundColor: "var(--accent-soft)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{icon}</Box>
    <Box>
      <Typography sx={{ fontFamily: "var(--font-heading)", fontWeight: 700, fontSize: "0.95rem", color: "var(--text-primary)", mb: 0.25 }}>{title}</Typography>
      <Typography sx={{ fontFamily: "var(--font-body)", fontSize: "0.78rem", color: "var(--text-muted)", mb: 0.5 }}>{subtitle}</Typography>
      <Typography sx={{ fontFamily: "var(--font-heading)", fontWeight: 700, fontSize: "1rem", color: "var(--text-primary)", wordBreak: "break-word" }}>{detail}</Typography>
    </Box>
  </Box>
);

const Footer = () => {
  const { empresa = {} } = useContext(AuthContext);
  return (
    <footer style={{ backgroundColor: "var(--bg-subtle)", borderTop: "1px solid var(--border)", marginTop: "auto" }} role="contentinfo">
      <Container maxWidth={false} sx={{ maxWidth: "var(--container-max)", py: { xs: 4, md: 5 }, px: { xs: 2, md: 3 } }}>
        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={12} sm={4} md={3}>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, p: 3, backgroundColor: "var(--bg-card)", borderRadius: "var(--radius-lg)", border: "1px solid var(--border)", height: "100%", justifyContent: "center" }}>
              <img src={empresa?.imagen_sitio ? `${appUrl}${empresa.imagen_sitio}` : logo} alt="logo" style={{ maxHeight: 70, maxWidth: "80%", objectFit: "contain" }} />
              <RedesDiv />
            </Box>
          </Grid>
          <Grid item xs={12} sm={8} md={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}><ContactCard title="Atención Telefónica" subtitle="LU-VI 9:00 a 18:00 | SA 9:00 a 13:00" detail={empresa?.telefonos_sitio || "+54 999 999999"} icon={<SupportAgent sx={{ color: "var(--accent)", fontSize: 22 }} />} /></Grid>
              <Grid item xs={12} md={6}><ContactCard title="Correo Electrónico" subtitle="Para consultas envíenos un correo" detail={empresa?.email_sitio || "empresa@gmail.com"} icon={<Email sx={{ color: "var(--accent)", fontSize: 22 }} />} /></Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box sx={{ mt: 4, pt: 3, borderTop: "1px solid var(--border)", textAlign: "center" }}>
          <Typography sx={{ fontFamily: "var(--font-body)", fontSize: "0.78rem", color: "var(--text-muted)", lineHeight: 1.6 }}>© {new Date(empresa?.createdAt).getFullYear() || "2025"} {empresa?.nombre_sitio || "Empresa Srl"} · Todos los derechos reservados<br />{empresa?.domicilio_sitio || "Argentina"}</Typography>
        </Box>
      </Container>
      <ContactFlotanteDiv />
    </footer>
  );
};
export default Footer;
